import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { getBuyboxCategoryByMonetizationGraphql } from '@/helpers/offer-helper';
import { BuyboxOfferCategory } from '@/interfaces/buybox';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import GridOfferMoreInfoExp from '@/components/experiments/GridBuyboxRedesignExps/components/GridOfferMoreInfoExp.vue';

interface Props {
	offer: TitleOfferFragment;
	title: TitleDetail;
	additionalContexts?: SnowplowContext[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GridPromotedOfferCardMoreInfoV1',
  props: {
    offer: null,
    title: null,
    additionalContexts: { default: () => [] }
  },
  emits: ['clickOut'],
  setup(__props: any) {

const props = __props as { offer: TitleOfferFragment, title: TitleDetail, additionalContexts: SnowplowContext[] };





const { t } = useI18n();

const categoryLabel = computed(() => {
	const category = getBuyboxCategoryByMonetizationGraphql(props.offer.monetizationType);
	const labels: Partial<Record<BuyboxOfferCategory, string>> = {
		[BuyboxOfferCategory.STREAM]: t('WEBAPP_STREAM') as string,
		[BuyboxOfferCategory.RENT]: t('WEBAPP_RENT') as string,
		[BuyboxOfferCategory.BUY]: t('WEBAPP_BUY') as string,
		[BuyboxOfferCategory.BUNDLE]: t('WEBAPP_BUNDLES') as string,
	};
	return category ? labels[category] ?? '' : '';
});

return { __sfc: true,props, t, categoryLabel, GridOfferMoreInfoExp }
}

})